var map = {
	"./Youtube-Large.svg": "af5e",
	"./blockdit-2-active.svg": "641b",
	"./blockdit-2.svg": "dfb4",
	"./blockdit-3.svg": "4e26",
	"./blockdit.svg": "012d",
	"./facebook.svg": "15aa",
	"./instagram.svg": "f59c",
	"./pantip.svg": "48c1",
	"./tiktok.svg": "834e",
	"./twitter.svg": "bb33",
	"./website.svg": "1eb0",
	"./youtube.svg": "293a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5762";